module.exports = __webpack_public_path__ + "resource/img/manage.0b897cc3.svg";